/**
 * Handles setting the document title of the current page
 * @param {string} title - String title.
 * @return {void}
 */
export default function setDocumentTitle(title) {
  document.title = title;
}
